const rawBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? "https://api.bytelogicindia.com/api";

export const API_BASE_URL = rawBaseUrl.replace(/\/$/, "");

export const LIVE_URL = "https://bytelogicindia.com"

//G-TAGS-ID
export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID
export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

export const API_ENDPOINTS = {
  homepage: "/v1/frontend/homepage",
  footer: "/v1/frontend/footer",
  navbar: "/v1/frontend/navbar",
  serviceTemplate: "/v1/frontend/service-template",
  solutionTemplate: "/v1/frontend/solution-template",
  serviceOrSolution: "/v1/frontend/service-or-solution",
  caseStudyTemplate: "/v1/frontend/case-study-template",
  aboutUs: "/v1/frontend/about-us",
  contactUs: "/v1/frontend/contact-us",
  careerCms: "/v1/frontend/career-cms",
  websitePortfolioCms: "/v1/frontend/website-portfolio-cms",
  seoPortfolioCms: "/v1/frontend/seo-portfolio-cms",
  globalPortfolioCms: "/v1/frontend/global-portfolio-cms",
  jobOpenings: "/v1/frontend/job-openings",
  jobOpeningOptions: "/v1/frontend/job-openings/options",
  contactLeads: "/v1/frontend/contact-leads",
  subscriptions: "/v1/frontend/subscriptions",
  visitorsTrack: "/v1/frontend/visitors/track",
  jobApplications: "/v1/frontend/job-applications",
  globalDetails: "/v1/frontend/global-details",
  blogCms: "/v1/frontend/blog-cms",
  servicesCms: "/v1/frontend/services-cms",
  solutionsCms: "/v1/frontend/solutions-cms",
  privacyPolicy: "/v1/frontend/privacy-policy",
  blogs: "/v1/frontend/blogs",
  blogCategories: "/v1/frontend/blog-categories",
  offers: "/v1/frontend/offers",
  seoCountries: "/v1/frontend/seo-countries",
} as const;
